import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Panel } from 'primereact/panel'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Btn, PageHeader, InputText, TextBtn, PickingType, Badge } from '../../../../components'
import { getPickingById } from '../../../../services/api/https/picking/picking.http'
import { changeStatusPickingToProntoParaDownload } from '../../../../services/api/https/system/system.http'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import { tableCellCentered } from '../../../../assets/js/styles'
import { getUsuarioInfo } from '../../../../services/localstorage/localstorage.service'
import parsePickingStatus from '../../../../constants/picking-status'

const INITIAL_STATE = {
  pickingId: '',
  pickings: [],
  errorMessage: '',
  loadingMessage: null,
}

function AlterarStatusPicking({ history, dispatch }) {
  const [state, setState] = useState({ ...INITIAL_STATE })

  useEffect(() => {
    dispatch(showMessageBox(null, state.errorMessage))
  }, [state.errorMessage])

  useEffect(() => {
    if (state.loadingMessage) dispatch(showLoadingBox(state.loadingMessage, 'Aguarde . . .'))
    else dispatch(hideLoadingBox())
  }, [state.loadingMessage])

  const onBtnVoltarClicked = () => {
    history.goBack()
  }

  const onPickingChange = value => {
    setState(prevState => ({ ...prevState, pickingId: value }))
  }

  const searchPicking = pickingId => {
    if (pickingId.trim() === '')
      dispatch(showMessageBox(null, 'Insira um picking valido para pesquisar'))
    else {
      setState(prevState => ({ ...prevState, loadingMessage: 'Carregando' }))
      getPickingById(pickingId)
        .then(res => {
          if (res) {
            setState(prevState => ({
              ...prevState,
              pickings: [res],
              loadingMessage: null,
            }))
          } else {
            dispatch(showMessageBox(null, 'Nenhum picking encontrado com esse ID'))
            setState(prevState => ({ ...prevState, loadingMessage: null }))
          }
        })
        .catch(err => setState(prevState => ({ ...prevState, errorMessage: err, pickings: [] })))
        .finally(() => setState(prevState => ({ ...prevState, loadingMessage: null })))
    }
  }

  const salvarPicking = pickingId => {
    if (!pickingId) {
      dispatch(showMessageBox(null, ''))
      return
    }
    setState(prevState => ({ ...prevState, loadingMessage: 'Salvando' }))
    changeStatusPickingToProntoParaDownload(pickingId, getUsuarioInfo().id)
      .then(res => {
        if (res) {
          dispatch(showMessageBox('Status alterado com sucesso', null))
          setState(prevState => ({
            ...prevState,
            pickings: [res],
            loadingMessage: null,
          }))
        } else {
          dispatch(showMessageBox(null, 'Nenhum picking encontrado com esse ID'))
          setState(prevState => ({ ...prevState, loadingMessage: null }))
        }
      })
      .catch(err => setState(prevState => ({ ...prevState, errorMessage: err, pickings: [] })))
      .finally(() => setState(prevState => ({ ...prevState, loadingMessage: null })))
  }

  return (
    <React.Fragment>
      <PageHeader>S.29&nbsp;- Alterar Status Picking</PageHeader>
      <div style={{ marginTop: 20 }}>
        <Panel>
          <div className="p-grid p-align-center">
            <div className="p-col-3">
              <InputText label={'Id do Picking'} onChange={value => onPickingChange(value)} />
            </div>
            <div className="p-col-fixed" style={{ marginTop: 40, width: 'fit-content' }}>
              <Btn onClick={() => searchPicking(state.pickingId)}>Pesquisar</Btn>
            </div>
            {state.pickings.length > 0 ? (
              <div className="p-col-fixed" style={{ marginTop: 40, width: 'fit-content' }}>
                <Btn onClick={() => salvarPicking(state.pickings[0].id)}>
                  Alterar Para Pronto Para Download
                </Btn>
              </div>
            ) : null}
            <div className="p-col" style={{ display: 'inline-block', marginTop: 40 }}>
              <TextBtn onClick={onBtnVoltarClicked}>Voltar</TextBtn>
            </div>
          </div>
          <div className="p-grid p-col-12" style={{ marginTop: 10 }}>
            <DataTable value={state.pickings} emptyMessage="Nenhuma entrega para exibir">
              <Column field="id" header="Código" style={tableCellCentered()} />
              <Column field="name" header="Picking - Descrição" style={tableCellCentered(200)} />
              <Column field="style" header="Estilo" style={tableCellCentered()} />
              <Column
                field="type"
                header="Tipo"
                style={tableCellCentered()}
                body={pick => <PickingType type={pick.type} />}
              />
              <Column field="company_name" header="Empresa" style={tableCellCentered()} />
              <Column
                field="status"
                header="Status"
                style={tableCellCentered()}
                body={pick => {
                  const status = parsePickingStatus(pick.status)
                  return <Badge color={status.color}>{status.label}</Badge>
                }}
                bodyStyle={tableCellCentered()}
              />
            </DataTable>
          </div>
        </Panel>
      </div>
    </React.Fragment>
  )
}

export default connect()(withRouter(AlterarStatusPicking))
